import { useMemo } from 'react'

import i18n from 'modules/core/lib/i18n'

import { LockLocked } from '@factorialco/f0-react/icons/app'

import { useJobCatalogTreeVisibility } from 'modules/job_catalog/hooks/useJobCatalogTreeVisibility'
import {
  GroupedData,
  NODE_TYPES,
  getChildTypeText,
  normalizeNodeType,
} from 'modules/job_catalog/lib/nodesUtils'

export const useNodeColumns = (id: string) => {
  const { canSeeAttributes } = useJobCatalogTreeVisibility()

  const columns = useMemo(() => {
    const nodeType = normalizeNodeType(id || '')
    const baseColumns = []

    const nameColumnLabel = getChildTypeText(id) || ''

    baseColumns.push({
      label: nameColumnLabel,
      sorting: 'name' as const,
      render: (i: GroupedData) => ({
        type: 'text' as const,
        value: i.name?.length > 30 ? `${i.name?.slice(0, 30)}...` : i.name || '',
      }),
    })

    if (nodeType === NODE_TYPES.FUNCTION) {
      baseColumns.push({
        label: i18n.t('job_catalog.nodes.types.level.other'),
        render: (i: GroupedData) => ({
          type: 'tagList' as const,
          value: {
            type: 'dot' as const,
            max: 2,
            tags: (i.levels || []).map((level) => ({
              text: level,
              color: 'smoke' as const,
              description: level,
            })),
          },
        }),
      })
    }

    baseColumns.push({
      label: i18n.t('job_catalog.nodes.salary'),
      render: (i: GroupedData) => ({
        ...(canSeeAttributes
          ? {
              type: 'text' as const,
              value: i.salary || '-',
            }
          : {
              type: 'tag' as const,
              value: { icon: LockLocked },
            }),
      }),
    })

    return baseColumns
  }, [canSeeAttributes, id])

  return columns
}
